import apiClient from "../client";
import { AxiosError } from "axios";

export interface LogoutResponse {
  success: boolean;
  message: string;
}

export const logout = async (): Promise<LogoutResponse> => {
  try {
    const response = await apiClient.post<LogoutResponse>('/auth/logout');
    
    // Clear local storage
    localStorage.removeItem('user');
    
    return response.data;
  } catch (error: unknown) {
    // Clear local storage even if request fails
    localStorage.removeItem('user');
    
    if (error instanceof AxiosError) {
      throw error.response?.data || { success: false, message: 'Logout failed' };
    }
    throw { success: false, message: 'Logout failed' };
  }
};
